import React, { useState } from 'react';
import ReferralCard from './ReferralCard';
import { useReferral, sendReferralInvite } from './API/Api';
import { getCurrencyInfo, getShareLink } from './js/utility';
import ModalDialog from './ModalDialog';

const Referrals = () => {
    const { referral, error, loading } = useReferral();
    const [isLoading, setIsLoading] = useState(false);
    const [modalContent, setModalContent] = useState({ show: false, title: '', message: '', icon: '' });

    if (loading) {
        return <div className="text-center my-5">Loading...</div>;
    }

    if (error) {
        return <div className="text-center text-danger my-5">{error}</div>;
    }

    const { symbol: currencySymbol } = getCurrencyInfo(site['currency_code']);

    const ref_link = `${site['site_url']}/?ref=${data['id'] ? data['id'] : 1}`;
    const ref_link_m = `${site['mob_url']}/?ref=${data['id'] ? data['id'] : 1}`;

    const handleInvite = async (e) => {
        e.preventDefault();
        const email = e.target.email.value;
        if (!email) {
            alert("Please enter your friend's email address.");
            return;
        }
        setIsLoading(true);
        try {
            const response = await sendReferralInvite(email);
            if (response.status === "success") {
                setModalContent({
                    show: true,
                    title: 'Success',
                    message: response.success[0],
                    icon: 'checkmark-circle',
                });
            } else {
                setModalContent({
                    show: true,
                    title: 'Error',
                    message: 'An error occurred while sending an email.',
                    icon: 'close-circle',
                });
            }
        } catch (error) {
            setModalContent({
                show: true,
                title: 'Error',
                message: 'An error occurred. Please try again.',
                icon: 'close-circle',
            });
        }
        setIsLoading(false);
    };

    const handleCloseModal = () => {
        setModalContent({ show: false, title: '', message: '', icon: '' });
    };

    return (
        <>
            {referral && (
                <div className="row gx-2 gx-lg-3">
                    <ReferralCard
                        title="Total Referrals"
                        value={{ amount: referral.total_referrals }}
                        subtitle="Total Referred Users"
                        iconClass="fa-users"
                        link="/referral/referrals"
                    />
                    <ReferralCard
                        title="Active Referrals"
                        value={{ amount: referral.active_referrals }}
                        subtitle="Total Active Referrals"
                        iconClass="fa-user-check"
                        link="/referral/referrals"
                    />
                    <ReferralCard
                        title="Referral Earnings"
                        value={{ currency: currencySymbol, amount: referral.referral_earnings }}
                        subtitle="Total Referral Earnings"
                        iconClass="fa-wallet"
                        link="/referral/earnings?status=complete"
                        isCurrency={true}
                    />
                    <ReferralCard
                        title="Pending Earnings"
                        value={{ currency: currencySymbol, amount: referral.pending_earnings }}
                        subtitle="Earnings Unclaimed"
                        iconClass="fa-hourglass-half"
                        link="/referral/earnings?status=pending"
                        isCurrency={true}
                    />
                </div>
            )}
            
            <div className="card card-success mb-4">
                <div className="card-header">
                    <b className="card-title">Share your referral link with your friends & you will earn money</b>
                </div>
                <div className="card-body">
                    <div className="mb-3">
                        <label className="form-label">Referral Link (Mobile)</label>
                        <div className="input-group">
                            <input
                                className="form-control"
                                type="text"
                                value={ref_link_m}
                                onClick={(e) => e.target.select()}
                                readOnly
                            />
                            <button className="btn btn-success" onClick={() => window.open(getShareLink(ref_link_m, site['site_name'], site['name'], 'whatsapp'), '_blank')}>
                                <i className="bi bi-whatsapp"></i> Share
                            </button>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Referral Link</label>
                        <div className="input-group">
                            <input
                                className="form-control"
                                type="text"
                                value={ref_link}
                                onClick={(e) => e.target.select()}
                                readOnly
                            />
                            <button className="btn btn-success" onClick={() => window.open(getShareLink(ref_link, site['site_name'], site['name'], 'whatsapp'), '_blank')}>
                                <i className="bi bi-whatsapp"></i> Share
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card card-success mb-4">
                <div className="card-header">
                    <b className="card-title">Invite your friends via email & you will earn money</b>
                </div>
                <form method="POST" id="referral_invite" onSubmit={handleInvite}>
                    <div className="card-body">
                        <div className="mb-3">
                            <label className="form-label">Your Friend's Email</label>
                            <div className="input-group">
                                <input 
                                    className="form-control" 
                                    type="email" 
                                    name="email" 
                                    placeholder="yourfriend@gmail.com" 
                                    required />
                                <button className="btn btn-primary d-flex align-items-center" type="submit">
                                    {isLoading ? (<><div className="spinner-border spinner-border-sm me-2" role="status"></div>Sending...</>) : (<><i className="bi bi-envelope me-2"></i>Send Invite</>)}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <ModalDialog
                show={modalContent.show}
                title={modalContent.title}
                message={modalContent.message}
                icon={modalContent.icon}
                onClose={handleCloseModal}
            />
        </>
    );
};

export default Referrals;
